<div [ngClass]="{ 'dark text-white-dark': store.semidark }">
    <nav class="sidebar fixed bottom-0 top-0 z-50 h-full min-h-screen w-[260px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] transition-all duration-300">
        <div class="h-full bg-white dark:bg-[#0e1726]">
            <div class="flex items-center justify-between px-4 py-3">
                <a routerLink="/dashboard" class="main-logo flex shrink-0 items-center">
                    <img class="ml-[5px] w-40 flex-none" src="/assets/images/logo.png" alt="" />
                    <span class="align-middle text-2xl font-semibold ltr:ml-1.5 rtl:mr-1.5 dark:text-white-light lg:inline"></span>
                </a>
                <a
                    href="javascript:;"
                    class="collapse-icon flex h-8 w-8 items-center rounded-full transition duration-300 hover:bg-gray-500/10 hover:text-primary rtl:rotate-180 dark:text-white-light dark:hover:bg-dark-light/10"
                    (click)="storeData.dispatch({ type: 'toggleSidebar'})"
                >
                    <icon-carets-down class="m-auto rotate-90" />
                </a>
            </div>
            <ng-scrollbar class="relative !h-[calc(100vh-80px)]" appearance="compact">
                <ul class="relative space-y-0.5 p-4 py-0 font-semibold">


                    <li class="menu nav-item">
                        <a routerLink="/dashboard" class="nav-link group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-dashboard class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'dashboard' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>
                    <li class="accordion menu nav-item">
                        <button
                            type="button"
                            class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('registers') }"
                            (click)="toggleAccordion('registers')"
                        >
                            <div class="flex items-center">
                                <icon-menu-components class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'registers' | translate }}</span
                                >
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('registers') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('registers')" class="accordion-content">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/hospitals" routerLinkActive="active" (click)="toggleMobileMenu()">{{ 'Hospitals' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/health-plans" routerLinkActive="active" (click)="toggleMobileMenu()">{{ 'Health Plans' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/doctors" routerLinkActive="active" (click)="toggleMobileMenu()">{{ 'Doctors' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/surgical-procedures" routerLinkActive="active" (click)="toggleMobileMenu()">{{ 'Surgical Procedures' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li class="menu nav-item">
                        <a routerLink="/quotes" class="nav-link group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-invoice class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Quotes' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <!--<li class="accordion menu nav-item">
                        <button
                            type="button"
                            class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('ask-ai') }"
                            (click)="toggleAccordion('ask-ai')"
                        >
                            <div class="flex items-center">
                                <icon-menu-apps class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Ask the AI' | translate }}</span
                                >
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('ask-ai') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('ask-ai')" class="accordion-content">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/dropzone" routerLinkActive="active" (click)="toggleMobileMenu()">{{ 'Dropzone' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/ask-me" routerLinkActive="active" (click)="toggleMobileMenu()">{{ 'Chat' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>-->

                    <li class="accordion menu nav-item">
                        <button
                            type="button"
                            class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('settings') }"
                            (click)="toggleAccordion('settings')"
                        >
                            <div class="flex items-center">
                                <icon-menu-elements class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Settings' | translate }}</span
                                >
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('settings') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('settings')" class="accordion-content">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/settings/users" routerLinkActive="active" [attr.disabled]="!isAdmin ? true : null"
                                    [ngClass]="{'disabled-link': !isAdmin}" (click)="toggleMobileMenu()">{{ 'Users' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li class="menu nav-item">
                        <a routerLink="/pages/faq" class="nav-link group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-notes class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'about' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>
                </ul>
            </ng-scrollbar>
        </div>
    </nav>
</div>
